<template>
  <div>
    <div class="flex items-center justify-between">
      <ActionLinks
        class="caption-bold py-8"
        variant="small"
        :with-tradein="false"
      />
      <div class="flex items-center gap-24">
        <CountrySwitchMenu />
        <RevLink
          v-if="helpLinkOnTop"
          class="flex items-center gap-4"
          :to="`/${locale}/help`"
          :tracking="{ name: i18n(translations.help), zone: 'header' }"
          :underlined="false"
        >
          <IconQuestionMarkInCircle class="h-16 w-16" />
          <span class="caption-bold">
            {{ i18n(translations.help) }}
          </span>
        </RevLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useI18nLocale } from '@backmarket/nuxt-module-i18n/useI18nLocale'
import { RevLink } from '@ds/components/Link'
import { IconQuestionMarkInCircle } from '@ds/icons/IconQuestionMarkInCircle'

import ActionLinks from './ActionLinks.vue'
import CountrySwitchMenu from './CountrySwitch/CountrySwitchMenu.vue'
import translations from './TopHeader.translations'

const experiments = useExperiments()

const hasImproveSearchUIExperiment =
  experiments['experiment.improveSearchUi'] === 'new'

const helpLinkOnTop =
  experiments['experiment.helpHeader'] === 'top' || hasImproveSearchUIExperiment

const i18n = useI18n()
const locale = useI18nLocale()
</script>
